import { Box, Typography, useTheme } from "@mui/material";
import React from "react";

/////////////////////////////////////////////////////////////////////////////////

interface IProps {
    text: string;
    backgroundColor: any;
    color: any;
    onClick?: () => void;
}

export const MprcChoice: React.FC<IProps> = (props) => {

    const { text, backgroundColor, color, onClick } = props;

    const theme = useTheme();

    return (
        <Box
            sx={{
                width: "100%",
                paddingY: theme.spacing(1),
                borderRadius: "20px",
                backgroundColor,
                color,
                "&:hover": onClick
                    ? {
                        backgroundColor: theme.palette.highlight.light,
                        color: theme.palette.common.white,
                        cursor: "pointer"
                    }
                    : {}
            }}
            onClick={onClick}
        >
            <Typography variant="caption" component="div" paddingX={2} color="inherit">
                {text}
            </Typography>
        </Box>
    );
};
